import { render, staticRenderFns } from "./VehicleModelListEdit.vue?vue&type=template&id=a466b526&"
import script from "./VehicleModelListEdit.vue?vue&type=script&lang=js&"
export * from "./VehicleModelListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports